import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from '../api-base.service';
import ApiOptionsConfig from '../api-options.config';

const BASE_URL = '/countries';

@Injectable({
  providedIn: 'root'
})
export class CountriesService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(countryId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${countryId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(countryId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${countryId}`), data);
  }

  delete(countryId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${countryId}`));
  }
}
